import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import VendorAccountsPage from "@/features/accounts/components/VendorAccountsPage";
import styles from "./music-vendors.module.scss";

/**
 * Existing Super Admin Music Vendors page — wired to canonical
 * Master Account list/create (kind=music-vendor) + Support Mode.
 * Roles / Pending Approvals pages remain separate nav entries.
 */
const MusicVendors: React.FC = () => (
  <VendorAccountsPage
    kind="music-vendor"
    title="Music Vendors"
    idColumnLabel="Music Vendor ID"
    addButtonLabel="Add Vendor"
    addModalTitle="Add New Music Vendor"
    styles={styles}
  />
);

export default withAuthenticationRequired(MusicVendors);
